var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"button"}},[_c('a',{staticClass:"button",attrs:{"type":"submit","href":_vm.links.facebookStand,"target":"_blank"}},[_vm._v("Eveniment Facebook")])])}
var staticRenderFns = []

export { render, staticRenderFns }